import { useTranslation } from 'react-i18next';

import { useSaveForumPost } from '~/api/forum/useSaveForumPost';
import { BookmarkButton } from '~/components';
import { toast } from '~/utils/toast';

type Props = {
  postId: number;
  saved: boolean;
};

export const SaveForumPostButton = ({ postId, saved }: Props) => {
  const mutation = useSaveForumPost(postId);

  const { t } = useTranslation(['common', 'forum']);

  return (
    <BookmarkButton
      disabled={mutation.isPending}
      isBookmarked={mutation.variables !== undefined ? mutation.variables : saved}
      onBookmark={(saved) =>
        mutation.mutate(saved, {
          onError: () => {
            mutation.reset();
            toast.danger({ description: t('common:error') });
          },
        })
      }
    />
  );
};
